import {useEffect, useRef} from 'react';

import {useBrands} from '../../provider/brands/brand-hook';
import {trackCounterpartyPageview} from '../../service/analytics/analytics-helper';

export function CounterpartyAnalytics(): null {
    const {firstBrand} = useBrands();
    const counterpartyId = firstBrand?.counterpartyId;
    const isTrackedRef = useRef<boolean>(false);

    // Fire once per session, as soon as the counterparty id is available after brands load.
    useEffect(() => {
        if (!isTrackedRef.current && typeof counterpartyId === 'number') {
            trackCounterpartyPageview(counterpartyId);
            isTrackedRef.current = true;
        }
    }, [counterpartyId]);

    return null;
}
